import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router/immutable';
import {
  entityReducer,
  menuReducer,
  viewReducer,
  viewInfoReducer,
  nodeReducer,
  webformReducer,
  blockReducer,
  paragraphReducer,
  taxonomyReducer,
  uiReducer,
  loginReducer,
  commerceReducer,
  userReducer,
} from '@uncinc/react-drupal-core';

import uiInternal from './UI';
import ordersReducer from './Orders';
import moodleCoursesReducer from './MoodleCourses';

const rootReducer = (history) => combineReducers({
  router: connectRouter(history),
  entity: entityReducer,
  menu: menuReducer,
  node: nodeReducer,
  webform: webformReducer,
  block: blockReducer,
  paragraph: paragraphReducer,
  view: viewReducer,
  viewInfo: viewInfoReducer,
  taxonomyTerm: taxonomyReducer,
  ui: uiReducer,
  uiInternal: uiInternal,
  login: loginReducer,
  commerce: commerceReducer,
  user: userReducer,
  orders: ordersReducer,
  moodleCourses: moodleCoursesReducer,
});

export default rootReducer;
